import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import tr from "./locales/tr.json";
import en from "./locales/en.json";

const STORAGE_KEY = "carbon-lang";
const defaultLanguage = "en";

const savedLang = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
const initialLanguage = savedLang === "en" || savedLang === "tr" ? savedLang : defaultLanguage;

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export const changeLanguageAndPersist = (lng) => {
  i18n.changeLanguage(lng);
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEY, lng);
  }
};

export default i18n;
